import PromoCodeActions from '../../../actions/PromoCodeActions';
import CustomNotify from "../../Notify";

export const actions = {
    getDataLink(id, success) {
        const params = {
            ids: id
        };

        PromoCodeActions.getListLinks(params, (response) => {
            if(response.items) {
                success && success(response.items[0]);
            } else {
                success && success(response[0]);
            }
        }, {});
    },

    deletePromoCode(id, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let params = {
            id: id
        };

        PromoCodeActions.deletePromoCode(params).then(resp => {
            if (resp.success) {
                CustomNotify(resp.success);
            }
            onSuccess && onSuccess();
        }).catch(error => {
            if (error && error.error) {
                CustomNotify(error.error, 'error');
            }
            onError && onError(error && error.error ? error.error.invalid_parameters : undefined);
        });
    }
};
